<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("calte.title") }}</h1>
    <form>
      <b-card class="w-50 mb-3">
        <form>
          <b-form-group
            id="serial"
            label-cols-sm="4"
            label-cols-lg="2"
            :label="this.$i18n.t('calte.label_serial')"
            label-for="input-horizontal"
          >
            <b-form-input v-model="serial" :placeholder="this.$i18n.t('calte.placeholder_serial')" @keydown.enter="search"></b-form-input>
          </b-form-group>
          <b-form-group
            id="code"
            label-cols-sm="4"
            label-cols-lg="2"
            :label="this.$i18n.t('calte.label_code')"
            label-for="input-horizontal"
          >
            <b-form-input v-model="code" :placeholder="this.$i18n.t('calte.placeholder_code')" @keydown.enter="search"></b-form-input>
          </b-form-group>
          <!-- 稼働計画番号 -->
          <b-form-group
            id="mo"
            label-cols-sm="4"
            label-cols-lg="2"
            :label="this.$i18n.t('calte.label_mo')"
            label-for="input-horizontal"
          >
            <b-form-input v-model="mo" :placeholder="this.$i18n.t('calte.placeholder_mo')"></b-form-input>
          </b-form-group>
          <!-- 申し送り事項 -->
          <b-form-group
            id="searchComments"
            label-cols-sm="4"
            label-cols-lg="2"
            :label="this.$i18n.t('calte.label_comments')"
            label-for="input-horizontal"
          >
            <b-form-input v-model="searchComments" :placeholder="this.$i18n.t('calte.placeholder_comments')"></b-form-input>
          </b-form-group>
          <div>
            <label>{{ $i18n.t("calte.either_mandatory") }}</label>
          </div>
          <div>
            <b-button variant="primary" @click="search" class="float-right px-5">{{ $i18n.t("calte.button_search") }}</b-button>
          </div>
        </form>
      </b-card>
    </form>
    <div v-if="isSearch">
      <b-card class="mb-3">
        <h2
          :class="showCollapse ? 'collapsed' : null"
          :aria-expanded="showCollapse ? 'true' : 'false'"
          aria-controls="collapse-12"
          @click="showCollapse = !showCollapse"
        >{{ $i18n.t("calte.label_serial_list") }}</h2>
        <b-collapse id="collapse-12" v-model="showCollapse" class="mt-3">
        <b-row>
        <b-col sm="5" md="1" class="my-1">
          <b-form-select
            v-model="perPage"
            id="perPageSelect"
            size="sm"
            :options="pageOptions"
          ></b-form-select>
        </b-col>
        <b-col sm="7" md="11" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-col>
        </b-row>
          <b-table
            :striped="striped"
            :bordered="bordered"
            :borderless="borderless"
            :outlined="outlined"
            :current-page="currentPage"
            :per-page="perPage"
            :small="small"
            :hover="hover"
            :dark="dark"
            :fixed="fixed"
            :foot-clone="footClone"
            :no-border-collapse="noCollapse"
            :items="serialItems"
            :fields="serialFields"
            :head-variant="headVariant"
            :table-variant="tableVariant"
            :tbody-tr-class="rowClass"
          >
            <template v-slot:cell(serial)="row">
              <u>
                <b-link
                  @click="serialSearch(row.item.serial, row.item.code, row.item.efFlg, row.item.mo)"
                  :class="showCollapse ? 'collapsed' : null"
                  :aria-expanded="showCollapse ? 'true' : 'false'"
                  aria-controls="collapse-12"
                >{{ row.item.serial }}</b-link>
              </u>
            </template>
          </b-table>
          <div>
            <b-button variant="primary" @click="serialCsv" class="float-right">{{ $i18n.t("calte.button_csv") }}</b-button>
          </div>
        </b-collapse>
      </b-card>
    </div>
    <div v-if="isSerial">
      <b-card>
        <h2>{{ $i18n.t("calte.label_process_list") }}</h2>
        <b-table
          :striped="striped"
          :bordered="bordered"
          :borderless="borderless"
          :outlined="outlined"
          :current-page="currentPage"
          :small="small"
          :hover="hover"
          :dark="dark"
          :fixed="fixed"
          :foot-clone="footClone"
          :no-border-collapse="noCollapse"
          :items="commonItems"
          :fields="commonFields"
          :head-variant="headVariant"
          :table-variant="tableVariant"
          class="mt-3"
        >
          <template v-slot:cell(delete)="row">
            <div v-if="row.item.delete === '1'">
              <b-button size="sm" class="mr-2" variant="danger" @click="discard">{{ $i18n.t("calte.button_discard") }}</b-button>
            </div>
            <div v-else>
              <b-button size="sm" class="mr-2" variant="danger" disabled>{{ $i18n.t("calte.button_discard") }}</b-button>
            </div>
          </template>
        </b-table>
        <b-table
          :striped="striped"
          :bordered="bordered"
          :borderless="borderless"
          :outlined="outlined"
          :current-page="currentPage"
          :small="small"
          :hover="hover"
          :dark="dark"
          :fixed="fixed"
          :foot-clone="footClone"
          :no-border-collapse="noCollapse"
          :items="processItems"
          :fields="processFields"
          :head-variant="headVariant"
          :table-variant="tableVariant"
        >
          <template v-slot:cell(edit)="row">
            <b-button size="sm" class="mr-2" @click="edit(row.item.condition, row.item.rounds, row.item.remarks)">{{ $i18n.t("calte.button_edit") }}</b-button>
          </template>
        </b-table>
        <div>
          <b-button variant="primary" @click="processCsv" class="float-right">{{ $i18n.t("calte.button_csv") }}</b-button>
        </div>
      </b-card>
    </div>
    <confirm-modal modId="md-alert" :msg="alertMsg" :titleMsg="titleMsg" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="alertModal"/>
    <yesNoModal modId="md-discard" :msg="this.$i18n.t('calte.confirm_discard')" :titleMsg="this.$i18n.t('calte.discard_serial')" :yesButtonMsg="this.$i18n.t('calte.button_discard')" :noButtonMsg="this.$i18n.t('common.cancel')" @confirm="discardModal"/>
    <confirm-modal modId="md-msg" :msg="msg" :titleMsg="titleMsg" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="confirm"/>
    <calteCommentsModal modId="md-comments" :msg="comments" :titleMsg="this.$i18n.t('calte.edit_comments')" :yesButtonMsg="this.$i18n.t('calte.update')" :noButtonMsg="this.$i18n.t('common.cancel')" @confirm="commentModal"/>

  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'
import yesNoModal from './YesNoModal'
import calteCommentsModal from './CalteCommentsModal'

export default {
  components: {
    confirmModal,
    yesNoModal,
    calteCommentsModal
  },
  data () {
    return {
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      alertMsg: '',
      msg: '',
      titleMsg: '',
      serial: '',
      code: '',
      mo: '',
      searchComments: '',
      condition: '',
      rounds: '',
      comments: '',
      currentPage: 1,
      totalRows: 1,
      modalResult: false,
      serialFields: [
        { key: 'serial', label: this.$i18n.t('calte.label_serial'), sortable: true },
        { key: 'code', label: this.$i18n.t('calte.label_code'), sortable: true },
        { key: 'mo', label: this.$i18n.t('calte.label_mo'), sortable: true },
        { key: 'date', label: this.$i18n.t('calte.label_process_date'), sortable: true },
        { key: 'efFlgStr', label: this.$i18n.t('calte.button_discard') }
      ],
      commonFields: [
        { key: 'serial', label: this.$i18n.t('calte.label_serial') },
        { key: 'code', label: this.$i18n.t('calte.label_code') },
        { key: 'mo', label: this.$i18n.t('calte.label_mo') },
        { key: 'delete', label: this.$i18n.t('calte.button_discard') }
      ],
      processFields: [
        { key: 'line', label: this.$i18n.t('calte.label_line'), sortable: true },
        { key: 'process', label: this.$i18n.t('calte.label_process'), sortable: true },
        { key: 'machine', label: this.$i18n.t('calte.label_machine'), sortable: true },
        { key: 'date', label: this.$i18n.t('calte.label_process_date'), sortable: true },
        { key: 'op', label: this.$i18n.t('calte.label_operator'), sortable: true },
        { key: 'okng', label: this.$i18n.t('calte.label_status'), sortable: true },
        { key: 'remarks', label: this.$i18n.t('calte.label_comments'), sortable: true },
        { key: 'edit', label: this.$i18n.t('calte.button_edit') }
      ],
      serialItems: [
      ],
      commonItems: [
      ],
      processItems: [
      ],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      showCollapse: true,
      noCollapse: true,
      isSearch: false,
      isSerial: false,
      from: '',
      to: '',
      serachedFlg: false
    }
  },
  created () {
    var headers = {
      'Content-Type': 'application/json',
      'opId': this.$store.store.state.opId,
      'ticketId': this.$store.store.state.ticketId
    }

    var body = {}
    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.$axios
      .post(window.END_POINT + '/common/checkLogin', body, {
        'headers': headers
      })
      .then(res => {
        console.log(res)
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            this.alertMsg = this.$i18n.t(res.data.message)
            this.titleMsg = this.$i18n.t('common.title_modal_error')
            this.$bvModal.show('md-err')
          }
        }
      })
      .catch(res => {
        // とりあえずログイン画面へ飛ばす
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        this.$router.push('/')
      })
    var linkSerial = this.$route.query.serial
    // パラメータ取得(別画面から来た場合)
    if (linkSerial !== undefined) {
      this.serial = String(linkSerial)
    }
    this.search()
  },
  methods: {
    search: function () {
      // 入力値チェック
      if (this.serial === '' && this.code === '' && this.mo === '' && this.searchComments === '') {
        this.alertMsg = this.$i18n.t('calte.err_calte_hissu')
        this.titleMsg = this.$i18n.t('common.title_modal_error')
        this.$bvModal.show('md-alert')
        return
      }

      var body = {}
      body.serial = this.serial
      body.code = this.code
      body.mo = this.mo
      body.comments = this.searchComments
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      // シリアル一覧取得
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/serial/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              // エラー表示
              this.alertMsg = this.$i18n.t(res.data.message)
              this.titleMsg = this.$i18n.t('common.title_modal_error')
              this.$bvModal.show('md-alert')
            }
          } else {
            var serialInfoList = res.data.serialInfo
            var serialItems = []
            if (serialInfoList.length === 0) {
              this.isSearch = false
              this.isSerial = false
              this.showCollapse = false
              this.alertMsg = this.$i18n.t('calte.err_not_serial')
              this.titleMsg = this.$i18n.t('calte.title')
              this.$bvModal.show('md-alert')
              return
            }
            // 整形
            for (var i = 0; i < serialInfoList.length; i++) {
              var serialItem = {}
              serialItem.serial = serialInfoList[i].serial
              serialItem.code = serialInfoList[i].code + ' - ' + serialInfoList[i].rev + ' - ' + serialInfoList[i].petname
              serialItem.mo = serialInfoList[i].mo
              // utc -> local 変換
              // momentオブジェクト(UTC)に変換
              var utc = this.$moment.utc(serialInfoList[i].passDate, 'YYYY-MM-DD HH:mm:ss')
              if (String(utc) === 'Invalid date') {
                serialItem.date = ''
              } else {
                // local時刻に変換＆フォーマット
                serialItem.date = utc.local().format('YYYY-MM-DD HH:mm:ss')
              }
              serialItem.efFlg = serialInfoList[i].efFlg
              if (serialInfoList[i].efFlg === '1') {
                serialItem.efFlgStr = ''
                serialItem.efFlg = serialInfoList[i].efFlg
              } else {
                serialItem.efFlgStr = this.$i18n.t('calte.label_discarded')
                serialItem.status = 'awesome'
                serialItem.efFlg = serialInfoList[i].efFlg
              }
              serialItems.push(serialItem)
            }
            // ページング設定
            this.totalRows = serialItems.length
            // 一旦データクリア
            this.serialItems.splice(0)
            // データセット
            this.serialItems.splice(0, 0, ...serialItems)

            this.isSearch = true

            // 工程内在庫から遷移してきた場合は通過履歴を表示(初回のみ)
            if (this.$route.query.serial !== undefined && this.serachedFlg === false) {
              var serial = this.serialItems[0].serial
              var code = this.serialItems[0].code
              var mo = this.serialItems[0].mo
              var efFlg = this.serialItems[0].efFlg
              this.serialSearch(serial, code, efFlg, mo)
              // 検索済みフラグをtrueにする
              this.serachedFlg = true
            } else {
              this.isSerial = false
              this.showCollapse = true
            }
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.alertMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-alert')
        })
    },
    serialSearch: function (trgSerial, trgCode, trgEfFlg, trgMo) {
      var body = {}
      body.serial = trgSerial
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      // 通過履歴一覧取得
      this.$axios
        .post(window.END_POINT + '/calte/process', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              // エラー表示
              this.alertMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-alert')
            }
          } else {
            var passHistoryInfoList = res.data.passHistoryInfo
            var processItems = []
            // 整形
            for (var i = 0; i < passHistoryInfoList.length; i++) {
              var processItem = {}
              processItem.line = passHistoryInfoList[i].line
              processItem.process = passHistoryInfoList[i].process
              processItem.machine = passHistoryInfoList[i].machine
              // utc -> local 変換
              // momentオブジェクト(UTC)に変換
              var utc = this.$moment.utc(passHistoryInfoList[i].passDate, 'YYYY-MM-DD HH:mm:ss')
              if (String(utc) === 'Invalid date') {
                processItem.date = ''
              } else {
                // local時刻に変換＆フォーマット
                processItem.date = utc.local().format('YYYY-MM-DD HH:mm:ss')
              }
              processItem.op = passHistoryInfoList[i].operator
              processItem.okng = passHistoryInfoList[i].status
              processItem.remarks = passHistoryInfoList[i].comments
              processItem.condition = passHistoryInfoList[i].condition
              processItem.rounds = passHistoryInfoList[i].rounds
              processItems.push(processItem)
            }
            // 通過履歴一覧データクリア
            this.processItems.splice(0)
            // 通過履歴一覧データセット
            this.processItems.splice(0, 0, ...processItems)
            // 通過履歴情報のシリアルと型番をセット
            var commonItems = [
              {
                serial: trgSerial,
                code: trgCode,
                mo: trgMo,
                delete: trgEfFlg
              }
            ]
            // シリアルと型番データクリア
            this.commonItems.splice(0)
            // シリアルと型番データセット
            this.commonItems.splice(0, 0, ...commonItems)
            this.isSerial = true
            this.showCollapse = false
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.alertMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-alert')
        })
    },
    discard: function () {
      this.$bvModal.show('md-discard')
    },
    discardModal: function () {
      this.$bvModal.hide('md-discard')
      if (this.modalResult) {
        // シリアル破棄
        this.discardSerial()
      }
    },
    discardSerial: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      var body = {
        'serial': this.commonItems[0].serial
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .delete(window.END_POINT + '/delete/serialDiscard',
          {
            'headers': headers,
            'data': body
          })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              // エラー表示
              this.alertMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-alert')
            }
          } else {
            var trgSerial = this.commonItems[0].serial
            var trgCode = this.commonItems[0].code
            var trgMo = this.commonItems[0].mo
            var trgEfFlg = '0'
            var commonItems = [
              {
                serial: trgSerial,
                code: trgCode,
                mo: trgMo,
                delete: trgEfFlg
              }
            ]
            // シリアルと型番データクリア
            this.commonItems.splice(0)
            // シリアルと型番データセット
            this.commonItems.splice(0, 0, ...commonItems)
            // 完了メッセージ
            this.msg = this.$i18n.t('calte.info_discard')
            this.titleMsg = this.$i18n.t('calte.discard_serial')
            this.$bvModal.show('md-msg')
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.alertMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-alert')
        })
    },
    edit: function (condition, rounds, comments) {
      this.comments = comments
      this.rounds = rounds
      this.condition = condition
      this.$bvModal.show('md-comments')
    },
    commentModal: function () {
      this.$bvModal.hide('md-comments')
      if (this.modalResult) {
        // 備考編集
        this.editComments()
      }
      this.comments = ''
    },
    editComments: function () {
      var body = {}
      body.mcondition = this.condition
      body.serial = this.commonItems[0].serial
      body.rounds = this.rounds
      body.comments = this.comments
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      // 備考更新
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/serial/update', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              // エラー表示
              this.alertMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-alert')
            }
          } else {
            // 完了メッセージ
            this.msg = this.$i18n.t('calte.info_comments')
            this.titleMsg = this.$i18n.t('calte.edit_comments')
            this.$bvModal.show('md-msg')
            // 通過履歴一覧再表示
            this.serialSearch(this.commonItems[0].serial, this.commonItems[0].code, this.commonItems[0].delete, this.commonItems[0].mo)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.alertMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-alert')
        })
    },
    serialCsv: function () {
      // タイトル設定
      var title = []
      this.serialFields.forEach(el => {
        title.push('"' + el['label'] + '"')
      })
      var csv = title.join(',')
      csv += '\r\n'
      // データ設定
      var data = []
      this.serialItems.forEach(el => {
        data = []
        data.push('"' + el['serial'] + '"')
        data.push('"' + el['code'] + '"')
        data.push('"' + el['mo'] + '"')
        data.push('"' + el['date'] + '"')
        data.push('"' + el['efFlg'] + '"')
        csv += data.join(',')
        csv += '\r\n'
      })
      // CSVダウンロード
      window.downloadCsv(csv, 'SerialSelectResult')
    },
    processCsv: function () {
      // タイトル設定
      var title1 = []
      this.commonFields.forEach(el => {
        title1.push('"' + el['label'] + '"')
      })
      var csv = title1.join(',')
      csv += '\r\n'
      // データ設定
      var data1 = []
      this.commonItems.forEach(el => {
        data1 = []
        data1.push('"' + el['serial'] + '"')
        data1.push('"' + el['code'] + '"')
        data1.push('"' + el['mo'] + '"')
        data1.push('"' + el['delete'] + '"')
        csv += data1.join(',')
        csv += '\r\n'
      })
      // タイトル設定
      var title2 = []
      this.processFields.forEach(el => {
        title2.push('"' + el['label'] + '"')
      })
      title2.splice(7)
      csv += title2.join(',')
      csv += '\r\n'
      // データ設定
      var data2 = []
      this.processItems.forEach(el => {
        data2 = []
        data2.push('"' + el['line'] + '"')
        data2.push('"' + el['process'] + '"')
        data2.push('"' + el['machine'] + '"')
        data2.push('"' + el['date'] + '"')
        data2.push('"' + el['op'] + '"')
        data2.push('"' + el['okng'] + '"')
        data2.push('"' + el['remarks'] + '"')
        csv += data2.join(',')
        csv += '\r\n'
      })
      // CSVダウンロード
      window.downloadCsv(csv, 'PassHistoryResult')
    },
    rowClass: function (item, type) {
      if (!item) return
      if (item.status === 'awesome') return 'table-danger'
    },
    confirm: function () {
      this.$bvModal.hide('md-msg')
    },
    alertModal: function () {
      this.$bvModal.hide('md-alert')
      this.alertMsg = ''
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Calte.vue